var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _rect, _path14, _path15, _path16, _path17, _mask, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFreezerClosed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 327,
    height: 417,
    fill: "none",
    viewBox: "-25 -30 350 450",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#8AADC6",
    d: "M4 45h286v321a5 5 0 0 1-5 5H9a5 5 0 0 1-5-5V45z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#9ABBD3",
    d: "M18 57h24v320H18zM251 57h24v320h-24z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#DFDFDF",
    d: "M42 195h209l24 13H18l24-13z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M15 208h260v11H15v-11z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#E9E9E9",
    fillRule: "evenodd",
    d: "M290 45H4v363a3 3 0 0 0 3 3h280a3 3 0 0 0 3-3V45zM21 61.84a3 3 0 0 0-3 3v327.442a3 3 0 0 0 3 3h251a3 3 0 0 0 3-3V64.841a3 3 0 0 0-3-3H21z",
    clipRule: "evenodd"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#E9E9E9",
    fillRule: "evenodd",
    d: "M290 45H4v315h286V45zm-15 12H18v289h257V57z",
    clipRule: "evenodd"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#D4D4D4",
    fillRule: "evenodd",
    d: "M290 45h-29v16.84h9a5 5 0 0 1 5 5v323.442a5 5 0 0 1-5 5h-9V411h26a3 3 0 0 0 3-3V45z",
    clipRule: "evenodd"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#38B0DC",
    d: "M0 3a3 3 0 0 1 3-3h289a3 3 0 0 1 3 3v42H0V3z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#54BCE3",
    d: "M0 3a3 3 0 0 1 3-3h114.927c2.649 0 3.998 3.181 2.157 5.085L81.5 45H0V3z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#15A5DA",
    d: "M261 3a3 3 0 0 1 3-3h28a3 3 0 0 1 3 3v42h-34V3z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#C4C4C4",
    d: "M12 411h19v6H12zM263 411h19v6h-19z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#182225",
    fillOpacity: 0.08,
    d: "M21 62h254v290H21z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M17 51a5 5 0 0 0-5 5v299a5 5 0 0 0 5 5h260a5 5 0 0 0 5-5V56a5 5 0 0 0-5-5H17zm11.217 14.218a3 3 0 0 0-3 3V343.73a3 3 0 0 0 3 3h236.622a3 3 0 0 0 3-3V68.218a3 3 0 0 0-3-3H28.217z",
    clipRule: "evenodd"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 88,
    x: 18,
    y: 85,
    fill: "#54BCE3",
    rx: 8
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#15A5DA",
    d: "M29 86a5 5 0 0 1 5 5v76a5 5 0 0 1-5 5V86z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M268 58.5l-236 292h38l203-251V74l-5-15.5zM235 56L18 331l4.5 5.5L247.5 56 235 49.5V56z",
    opacity: 0.2
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#54BCE3",
    d: "M150.5 401H12v-45h226l-87.5 45z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#38B0DC",
    d: "M138 356h144v45H99.5l38.5-45z"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "a",
    width: 67,
    height: 35,
    x: 221,
    y: 5,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 65.182,
    height: 34.143,
    x: 221.818,
    y: 5.857,
    fill: "#C4C4C4",
    rx: 1
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#4873E2",
    d: "M287 5.857h-65.182V40H287V5.857z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#254FBB",
    d: "M221.818 5.857H287v1.366h-65.182z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#254FBB",
    d: "M221.818 40V5.857h1.105v32.777L221.818 40z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M292.5 7.223L254.842 40h5.041l36.429-32.777H292.5zM262.064 7.223L223.08 40h25.151l39.242-32.777h-25.409z",
    opacity: 0.2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFreezerClosed);
export default __webpack_public_path__ + "static/media/freezer-closed.0e9f657bf7470ed35a09a918953eca05.svg";
export { ForwardRef as ReactComponent };